(function (_) {
    'use strict';

    _['NOTIFICATIONS_TITLE'] = 'Notificações';
    _['NOTIFICATIONS.POPUP.TITLE'] = 'Notificações não lidas';
    _['NOTIFICATIONS.POPUP.MSG'] = 'Tens notificações não lidas no centro de notificação.';
    _['NOTIFICATIONS.POPUP.BTN'] = 'Ver notificações';
    _['NOTIFICATIONS.NO-NOTIFICATIONS'] = 'Ainda não há notificações.';
    _['NOTIFICATIONS.NO-PERMISSION'] = 'Notificações push estão desativadas para este app.';

}(translations['pt']));



// WEBPACK FOOTER //
// ./src/app/modules/notifications/lang/notifications-lang_pt.js